/**
 * Faculty 5 — Leadership-style section: optional full-bleed background image
 * behind a centered title + description, with a responsive row of leader cards
 * (photo, name, bio, and up to three company logos per card).
 *
 * Reuses existing faculty columns (`title`, `title_text_color`,
 * `title_1_color`, `description`, `description_text_color`, `background_color`,
 * `metadata`) and adds two new columns (`background_image`,
 * `background_image_alt`) — see migration 20260601180000-faculty-variant-5.js.
 */

export const FACULTY_5_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    priority: 1,
    status: true,
    metaImg: "",
    altImg: "",
    metaTitle: "Leader Name",
    metaDescription: "Designation / short bio",
    companyLogo1: "",
    companyLogo2: "",
    companyLogo3: "",
  },

  METADATA_TITLES: {
    metadata: "Leadership Cards",
  },

  FACULTY_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label:
        "Title (wrap highlight in { } e.g. Meet Our {Leadership})",
      value: "Meet Our {Leadership}",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Meet Our {Leadership}",
      required: false,
      defaultValue: "Meet Our {Leadership}",
      rows: 2,
    },
    {
      fieldName: "title_text_color",
      label: "Title / text color",
      value: "#1A1A1A",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#1A1A1A",
      required: false,
      defaultValue: "#1A1A1A",
    },
    {
      fieldName: "title_1_color",
      label: "Title highlight color (for {...} text)",
      value: "#E36E26",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E36E26",
      required: false,
      defaultValue: "#E36E26",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Short supporting line under the title",
      required: false,
      rows: 2,
    },
    {
      fieldName: "description_text_color",
      label: "Description text color",
      value: "#1A1A1A",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#1A1A1A",
      required: false,
      defaultValue: "#1A1A1A",
    },
    {
      fieldName: "background_color",
      label: "Section background color (used when no background image)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "background_image",
      label: "Background image (optional, full-bleed behind the section)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload background image",
      required: false,
    },
    {
      fieldName: "background_image_alt",
      label: "Background image alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the background image",
      required: false,
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Priority",
      fieldName: "priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Sort order (1, 2, 3…)",
      required: true,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show/Hide this card",
      defaultValue: true,
    },
    {
      header: "Photo",
      fieldName: "metaImg",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload leader photo (276×156)",
    },
    {
      header: "Photo alt text",
      fieldName: "altImg",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the photo",
    },
    {
      header: "Name",
      fieldName: "metaTitle",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Leader name",
    },
    {
      header: "Designation / bio",
      fieldName: "metaDescription",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Designation or short bio",
      rows: 3,
    },
    {
      header: "Company logo 1",
      fieldName: "companyLogo1",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload company logo (114×60)",
    },
    {
      header: "Company logo 2",
      fieldName: "companyLogo2",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload company logo (114×60)",
    },
    {
      header: "Company logo 3",
      fieldName: "companyLogo3",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload company logo (114×60)",
    },
  ],
};
